var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.772,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon map-parking",
    d: "M7.237 0H0v16h3.52v-5.12h3.717c3.988 0 5.534-3.159 5.534-5.766S11.226 0 7.237 0zm-.964 7.68H3.52v-4.8h2.753c1.636 0 3.094.361 3.094 2.4s-1.458 2.4-3.094 2.4z",
    fill: "#7cba25"
  })));
}
export default SvgMapParking;